// extracted by mini-css-extract-plugin
export default {"container":"MenuLink_container__apvdy","link":"MenuLink_link__rHkJA","subMenu":"MenuLink_subMenu__0ETnq","arrow":"MenuLink_arrow__kVq85"};